// src/i18n/locales/de/progress.ts

export default {
  title: 'Dein Fortschritt',
  subtitle: 'Verfolge deine Erfolge und bleib motiviert auf deinem Weg zum Ziel!',
  loadingData: 'Lade Fortschrittsdaten...',

  header: {
    title: 'Dein Fortschritt',
    subtitle: 'Verfolge deine Erfolge und bleib motiviert auf deinem Weg zum Ziel!'
  },

  stats: {
    currentWeight: 'Aktuelles Gewicht',
    targetWeight: 'Zielgewicht',
    weightLost: 'Gewicht verloren',
    planAdherence: 'Plan-Treue',
    thisWeek: 'Diese Woche',
    stillToGo: 'Noch {{amount}} kg',
    sinceStart: 'Seit Start',
    excellent: 'Ausgezeichnet!',
    good: 'Gut!',
    keepGoing: 'Weiter so!',
    days: '{{count}} Tage',
    currentStreak: 'Aktuelle Serie',
    longestStreak: 'Längste Serie',
    totalDays: 'Aktive Tage',
    weightEntries: 'Gewichtseinträge',
    photoCount: 'Fotos',
    sinceLast: 'Seit letzter Woche',
    needsWork: 'Verbesserungsbedarf'
  },

  weightChart: {
    title: 'Gewichtsverlauf',
    week: 'Woche',
    month: 'Monat',
    all: 'Gesamt',
    noData: 'Keine Daten verfügbar',
    addFirstEntry: 'Füge dein erstes Gewicht hinzu',
    currentWeight: 'Aktuelles Gewicht',
    targetWeight: 'Zielgewicht',
    trend: 'Trend',
    timeRange: {
      week: '7 Tage',
      month: '30 Tage',
      quarter: '90 Tage',
      all: 'Alle'
    }
  },

  weightHistory: {
    title: 'Gewichtsverlauf Details',
    logWeight: 'Gewicht eintragen',
    compare: 'Vergleichen',
    selectForCompare: 'ausgewählt',
    table: {
      date: 'Datum',
      weight: 'Gewicht',
      change: 'Veränderung',
      toTarget: 'Bis zum Ziel',
      photo: 'Foto',
      status: 'Status',
      note: 'Notiz',
      actions: 'Aktionen'
    },
    noEntries: 'Noch keine Einträge',
    noEntriesSubtext: 'Füge dein erstes Gewicht hinzu, um deinen Fortschritt zu verfolgen',
    start: 'Start',
    confirmDelete: 'Möchtest du diesen Eintrag wirklich löschen?',
    deleteSuccess: 'Eintrag gelöscht',
    deleteError: 'Fehler beim Löschen',
    compareMode: 'Vergleichsmodus',
    cancelCompare: 'Abbrechen',
    gained: '+{{amount}} kg',
    lost: '-{{amount}} kg',
    noChange: 'Keine Änderung',
    empty: 'Noch keine Gewichtseinträge',
    emptySubtext: 'Beginne damit, dein Gewicht zu tracken, um deinen Fortschritt zu sehen.'
  },

  // weeklyReport: {
  //   title: 'Wochenbericht',
  //   monday: 'Montag',
  //   tuesday: 'Dienstag',
  //   wednesday: 'Mittwoch',
  //   thursday: 'Donnerstag',
  //   friday: 'Freitag',
  //   saturday: 'Samstag',
  //   sunday: 'Sonntag',
  //   weeklyRate: 'Wochenrate',
  //   motivation: 'Weiter so!',
  //   motivationTextHigh: 'Herausragende Beständigkeit! Du zermalst deine Ernährungsziele. Diese Art von Hingabe wird deine Ergebnisse transformieren.',
  //   motivationTextMedium: 'Großartige Leistung diese Woche! Du bleibst auf Kurs. Ein paar weitere abgeschlossene Tage bringen dich in die Exzellenzzone.',
  //   motivationTextLow: 'Jeder Tag ist eine neue Gelegenheit. Lass dich von einer schwierigen Woche nicht entmutigen - morgen ist dein Neuanfang!',
  // },

  addWeight: {
    title: 'Gewicht hinzufügen',
    editTitle: 'Gewicht bearbeiten',
    subtitle: 'Erfasse dein aktuelles Gewicht',
    weight: 'Gewicht (kg)',
    weightPlaceholder: 'z.B. 75.5',
    date: 'Datum',
    notes: 'Notizen (optional)',
    notesPlaceholder: 'z.B. Motiviert und bereit!',
    photo: 'Fortschrittsfoto (optional)',
    uploadPhoto: 'Foto hochladen oder hierher ziehen',
    fileTypes: 'PNG, JPG bis zu 10MB',
    cancel: 'Abbrechen',
    add: 'Hinzufügen',
    update: 'Aktualisieren',
    tip: 'Tipp',
    tipText: 'Wiege dich am besten morgens nach dem Aufstehen und vor dem Frühstück für die genauesten Ergebnisse. Fotos helfen dir, Veränderungen zu sehen, die die Waage nicht zeigt!',
    success: 'Gewicht erfasst!',
    updateSuccess: 'Gewicht aktualisiert!',
    error: 'Fehler beim Speichern',
    invalidWeight: 'Bitte gültiges Gewicht eingeben',
    uploadError: 'Bitte nur Bilddateien hochladen',
    note: 'Notiz (optional)',
    notePlaceholder: 'z.B. Nach dem Training',
    save: 'Speichern'
  },

  weightDetail: {
    title: 'Fortschritt vom',
    subtitle: 'Deine Gewichtsmessung',
    weight: 'Gewicht',
    targetWeight: 'Zielgewicht',
    toTarget: 'Bis zum Ziel',
    change: 'Veränderung',
    start: 'Start',
    notes: 'Notizen',
    progress: 'Fortschritt',
    startMessage: 'Das ist dein Startgewicht. Du hast den ersten Schritt gemacht!',
    progressMessage: 'Du hast seit dem Start {{amount}} kg abgenommen. Weiter so!',
    edit: 'Bearbeiten',
    share: 'Teilen',
    shareText: '🎉 Fortschritt vom {{date}}!\n\nGewicht: {{weight}} kg\nZiel: {{target}} kg\n\n#NutriBot #Fitness #Progress',
    copiedToClipboard: 'In Zwischenablage kopiert!'
  },

  achievements: {
    title: 'Erfolge',
    filterAll: 'Alle',
    unlocked: 'Freigeschaltet',
    locked: 'Gesperrt',
    notUnlocked: 'Noch nicht freigeschaltet',
    unlockedOn: 'Erreicht am',
    category: 'Kategorie',
    details: 'Details',
    tip: 'Tipp',
    download: 'Herunterladen',
    copy: 'Kopieren',
    share: 'Teilen',
    achievementUnlocked: 'Achievement Unlocked!',
    shareText: '🏆 Ich habe das Achievement "{{title}}" freigeschaltet!\n{{description}}\n\n#NutriBot #Fitness #Achievement',
    copiedToClipboard: 'In Zwischenablage kopiert!',
    subtitle: 'Deine freigeschalteten Meilensteine',
    viewAll: 'Alle anzeigen',
    filterBy: 'Filtern nach',

    achieved: 'Erreicht',
    // tip: 'Tipp',
    downloadFailed: 'Bilderstellung fehlgeschlagen',
    downloadSuccess: 'Achievement heruntergeladen!',
    shareSuccess: 'Erfolgreich geteilt!',
    imageDownloaded: 'Bild heruntergeladen! Du kannst es jetzt manuell teilen.',
    // achievementUnlocked: 'Achievement freigeschaltet',

    categories: {
      all: 'Alle',
      weight_loss: 'Gewichtsverlust',
      streak: 'Serien',
      consistency: 'Beständigkeit',
      milestones: 'Meilensteine',
      special: 'Spezial'
    },
    modal: {
      title: 'Erfolg Details',
      description: 'Beschreibung',
      tips: 'Tipps',
      unlockedAt: 'Freigeschaltet',
      requirement: 'Anforderung',
      progress: 'Fortschritt',
      close: 'Schließen'
    },
    empty: 'Keine Erfolge freigeschaltet',
    emptySubtext: 'Erreiche deine Ziele, um Erfolge freizuschalten!',
    items: {
      firstSteps: {
        title: 'Erste Schritte',
        description: '1 kg verloren',
        details: 'Du hast dein erstes Kilogramm verloren! Das ist der Beginn deiner Transformation.',
        tips: 'Bleib konsequent bei deinem Plan und die Ergebnisse werden folgen.'
      },
      fiveKgMilestone: {
        title: '5 kg Meilenstein',
        description: 'Erstes Ziel erreicht',
        details: '5 Kilogramm weniger! Du bist auf dem richtigen Weg zu deinem Traumgewicht.',
        tips: 'Feiere diesen Erfolg, aber bleib fokussiert auf dein Endziel.'
      },
      tenKgChampion: {
        title: '10 kg Champion',
        description: 'Zielgewicht erreicht',
        details: 'Erreiche dein Zielgewicht und werde zum Champion deiner Gesundheit!',
        tips: 'Nur noch wenige Kilogramm bis zu deinem Ziel. Du schaffst das!'
      },
      fifteenKgLegend: {
        title: '15 kg Legende',
        description: 'Außergewöhnliche Leistung',
        details: 'Eine legendäre Transformation! 15 kg sind eine beeindruckende Leistung.',
        tips: 'Halte dein neues Gewicht und genieße dein gesünderes Leben.'
      },
      threeDayStreak: {
        title: '3 Tage Serie',
        description: 'Guter Start!',
        details: 'Drei Tage in Folge deinem Plan gefolgt. Toller Start!',
        tips: 'Die ersten Tage sind die schwersten. Du bist auf dem richtigen Weg!'
      },
      sevenDayStreak: {
        title: '7 Tage Serie',
        description: 'Eine Woche stark',
        details: 'Eine ganze Woche konsequent! Deine Disziplin zahlt sich aus.',
        tips: 'Nach einer Woche wird es zur Gewohnheit. Mach weiter so!'
      },
      fourteenDayStreak: {
        title: '14 Tage Serie',
        description: 'Zwei Wochen Power',
        details: 'Zwei Wochen ohne Unterbrechung! Du bist ein Vorbild für Beständigkeit.',
        tips: 'Deine Gewohnheiten sind jetzt fest etabliert. Bleib dran!'
      },
      thirtyDayStreak: {
        title: '30 Tage Serie',
        description: 'Einen Monat stark',
        details: 'Ein ganzer Monat! Das ist echte Hingabe und Disziplin.',
        tips: 'Nach 30 Tagen ist es Teil deines Lebens geworden.'
      },
      sixtyDayStreak: {
        title: '60 Tage Serie',
        description: 'Unaufhaltsam',
        details: 'Zwei Monate ohne Pause! Du bist eine Inspiration für andere.',
        tips: 'Du hast bewiesen, dass du alles erreichen kannst, was du dir vornimmst.'
      },
      ninetyDayStreak: {
        title: '90 Tage Serie',
        description: 'Lifestyle Champion',
        details: '90 Tage! Gesunde Ernährung ist jetzt dein Lifestyle.',
        tips: 'Du hast einen neuen Lifestyle etabliert. Glückwunsch!'
      },
      earlyBird: {
        title: 'Frühaufsteher',
        description: '10 Gewichtseinträge',
        details: 'Du trackst dein Gewicht regelmäßig. Tolle Disziplin!',
        tips: 'Regelmäßiges Tracking hilft dir, auf Kurs zu bleiben.'
      },
      dataMaster: {
        title: 'Daten-Meister',
        description: '30 Gewichtseinträge',
        details: '30 Einträge! Du bist ein Meister der Selbstüberwachung.',
        tips: 'Deine Daten zeigen deinen Fortschritt deutlich.'
      },
      photoStarter: {
        title: 'Foto Starter',
        description: '5 Fortschrittsfotos',
        details: 'Du dokumentierst deine Transformation visuell!',
        tips: 'Fotos zeigen Veränderungen, die die Waage vielleicht nicht offenbart.'
      },
      photoPro: {
        title: 'Foto Profi',
        description: '15 Fortschrittsfotos',
        details: 'Deine Foto-Dokumentation ist beeindruckend!',
        tips: 'Du wirst es lieben, auf deine Reise zurückzublicken.'
      },
      firstMonth: {
        title: 'Erster Monat',
        description: '30 aktive Tage',
        details: 'Einen Monat aktiv auf NutriBot!',
        tips: 'Du hast die Grundlage für langfristigen Erfolg gelegt.'
      },
      quarterChampion: {
        title: 'Quartals-Champion',
        description: '90 aktive Tage',
        details: 'Drei Monate Hingabe!',
        tips: 'Du bist der Beweis, dass Beständigkeit gewinnt.'
      },
      halfYearHero: {
        title: 'Halbjahres-Held',
        description: '180 aktive Tage',
        details: 'Ein halbes Jahr! Das ist eine echte Lifestyle-Änderung.',
        tips: 'Du hast deine Gewohnheiten vollständig transformiert.'
      },
      yearLegend: {
        title: 'Jahres-Legende',
        description: '365 aktive Tage',
        details: 'Ein volles Jahr! Du bist eine Ernährungs-Legende!',
        tips: 'Deine Hingabe ist eine Inspiration für alle.'
      }
    }
  },

  comparePhotos: {
    title: 'Fortschrittsvergleich',
    subtitle: 'Vorher & Nachher',
    before: 'Vorher',
    after: 'Nachher',
    weightLoss: 'Gewichtsverlust',
    timeframe: 'Zeitraum',
    days: '{{count}} Tage',
    dragToCompare: 'Ziehe den Regler, um zu vergleichen',
    beforeNotes: 'Vorher - Notizen',
    afterNotes: 'Nachher - Notizen',
    noPhotos: 'Keine Fotos verfügbar',
    noPhotosSubtext: 'Mindestens einer der ausgewählten Einträge hat kein Foto',
    progress: 'Fantastischer Fortschritt!',
    progressMessage: 'Du hast {{amount}} kg in {{days}} Tagen abgenommen! Das ist eine großartige Leistung. Bleib dran und du wirst dein Ziel erreichen! 💪',
    motivationMessage: 'Jeder Schritt zählt auf deiner Reise. Bleib fokussiert und die Ergebnisse werden folgen! 🌟'
  },

  progressPhotos: {
    title: 'Fortschrittsfotos',
    selectForCompare: '{{count}}/2 ausgewählt für Vergleich',
    noPhotos: 'Noch keine Fotos',
    noPhotosSubtext: 'Dokumentiere deine Transformation visuell',
    tip: 'Tipp',
    tipText: 'Wähle 2 Fotos aus, um einen Vorher-Nachher-Vergleich zu sehen!',
    gallery: 'Foto-Galerie',
    upload: 'Foto hochladen',
    empty: 'Noch keine Fotos',
    emptySubtext: 'Dokumentiere deine Transformation visuell.',
    compare: 'Fotos vergleichen',
    delete: 'Foto löschen',
    confirmDelete: 'Möchtest du dieses Foto wirklich löschen?',
    gridView: 'Rasteransicht',
    listView: 'Listenansicht',
    photosCount: '{{count}} Fotos'
  },

  weeklyReport: {
    title: 'Wöchentliche Zusammenfassung',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    weeklyRate: 'Wochenrate',
    motivation: 'Du machst das großartig!',
    motivationText: 'Mit deiner aktuellen Plan-Treue von 92% bist du auf dem besten Weg, dein Ziel zu erreichen. Bleib dran — du schaffst das! 💪',
    motivationTextHigh: 'Herausragende Beständigkeit! Du zermalst deine Ernährungsziele. Diese Art von Hingabe wird deine Ergebnisse transformieren.',
    motivationTextMedium: 'Großartige Leistung diese Woche! Du bleibst auf Kurs. Ein paar weitere abgeschlossene Tage bringen dich in die Exzellenzzone.',
    motivationTextLow: 'Jeder Tag ist eine neue Gelegenheit. Lass dich von einer schwierigen Woche nicht entmutigen - morgen ist dein Neuanfang!',
    weightChange: 'Gewichtsveränderung',
    avgCalories: 'Ø Kalorien/Tag',
    planAdherence: 'Plan-Treue',
    completedMeals: 'Erledigte Mahlzeiten',
    trend: 'Trend',
    exportPDF: 'Als PDF exportieren',
    weekDays: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag'
    }
  },

  buttons: {
    addWeight: 'Gewicht hinzufügen',
    uploadPhoto: 'Foto hochladen',
    viewDetails: 'Details anzeigen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    cancel: 'Abbrechen',
    save: 'Speichern',
    close: 'Schließen',
    compare: 'Vergleichen',
    download: 'Herunterladen'
  },

  uploadPhoto: {
    title: 'Fortschrittsfoto hochladen',
    selectFile: 'Foto auswählen',
    dragDrop: 'Oder hier ablegen',
    maxSize: 'Max. 5 MB',
    date: 'Datum',
    weight: 'Gewicht (optional)',
    weightPlaceholder: 'z.B. 75.5',
    note: 'Notiz (optional)',
    notePlaceholder: 'z.B. Woche 4',
    cancel: 'Abbrechen',
    upload: 'Hochladen',
    success: 'Foto hochgeladen!',
    error: 'Upload fehlgeschlagen',
    compressing: 'Bild wird komprimiert...',
    uploading: 'Wird hochgeladen...'
  },

  success: {
    weightAdded: 'Gewichtseintrag hinzugefügt!',
    weightDeleted: 'Eintrag gelöscht',
    photoUploaded: 'Foto hochgeladen!',
    photoDeleted: 'Foto gelöscht',
    achievementUnlocked: '🎉 Erfolg freigeschaltet: {{title}}'
  },

  error: {
    loadFailed: 'Fehler beim Laden',
    addFailed: 'Hinzufügen fehlgeschlagen',
    deleteFailed: 'Löschen fehlgeschlagen',
    uploadFailed: 'Upload fehlgeschlagen',
    invalidFile: 'Ungültige Datei',
    fileTooLarge: 'Datei zu groß (max. 5 MB)',
    required: 'Pflichtfeld',
    invalidWeight: 'Ungültiges Gewicht',
    invalidDate: 'Ungültiges Datum'
  }
};